import {
  Container,
  Grid,
  Input,
  Select,
  Stack,
  Text,
  useBasisFormContext,
} from "basis";
import { Region } from "library/accounts/types";
import { stateOptions } from "library/sharedOptions";
import { ResidentialFormValues } from "../../types";
import { validateLength, validatePostcode } from "./formValidation";

type Props = {
  region: Region;
};

export const ManualAddress = ({ region }: Props) => {
  const { Field } = useBasisFormContext<ResidentialFormValues>();
  if (region === "NZ") {
    return (
      <Stack gap="8">
        <Stack gap="2">
          <Text>
            <strong>Country</strong>
          </Text>
          <Text>New Zealand</Text>
        </Stack>
        <Field
          as={Input}
          label="Street address"
          name="address.address1"
          maxLength={40}
          validate={validateLength}
          helpText="We do not accept PO Box as a valid address"
        />
        <Grid cols-xs="2" colsGap-xs="4" rowsGap="8">
          <Grid.Item>
            <Field
              as={Input}
              label="Suburb"
              name="address.nzSuburb"
              optional
              maxLength={40}
              validate={validateLength}
            />
          </Grid.Item>
          <Grid.Item>
            <Field
              as={Input}
              label="City"
              name="address.city"
              maxLength={40}
              validate={validateLength}
            />
          </Grid.Item>
        </Grid>
        <Container width="200">
          <Field
            as={Input}
            label="Postcode"
            name="address.postcode"
            maxLength={10}
            validate={validatePostcode}
          />
        </Container>
      </Stack>
    );
  }

  return (
    <Stack gap="8">
      <Stack gap="2">
        <Text>
          <strong>Country</strong>
        </Text>
        <Text>Australia</Text>
      </Stack>
      <Field
        as={Input}
        label="Street address 1"
        name="address.address1"
        maxLength={40}
        validate={validateLength}
        helpText="We do not accept PO Box as a valid address"
      />
      <Field
        as={Input}
        label="Street address 2"
        name="address.address2"
        optional
        maxLength={40}
        validate={validateLength}
      />
      <Grid cols-xs="2" colsGap-xs="4" rowsGap="8">
        <Grid.Item>
          <Field
            as={Input}
            label="City/town/suburb"
            name="address.city"
            maxLength={40}
            validate={validateLength}
          />
        </Grid.Item>
        <Grid.Item>
          <Field
            as={Select}
            label="State"
            name="address.state"
            options={stateOptions}
          />
        </Grid.Item>
      </Grid>
      <Container width="200">
        <Field
          as={Input}
          label="Postcode"
          name="address.postcode"
          maxLength={10}
          validate={validatePostcode}
        />
      </Container>
    </Stack>
  );
};
